import { render, staticRenderFns } from "./TodoStatistic.vue?vue&type=template&id=30ff89db&scoped=true&"
import script from "./TodoStatistic.vue?vue&type=script&lang=js&"
export * from "./TodoStatistic.vue?vue&type=script&lang=js&"
import style0 from "./TodoStatistic.vue?vue&type=style&index=0&id=30ff89db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff89db",
  null
  
)

export default component.exports